import React from 'react';
import { Box } from '@mui/system';
import Calendar from './Calendar';

const CalendarPage = () => {
  return (
    <Box component={'span'}>
      <div className="contactus-hero">NMZ Calendar</div>
      <Calendar fullPage={true} />
      <Box sx={{ width: '100%' }}></Box>
    </Box>
  );
};

export default CalendarPage;
